'use strict'

import Snap from 'snapsvg'
import Carousel from '../../_modules/carousel/carousel.js'

// use inline'd jquery for Bootstrap init
var $ = window.$
require('bootstrap')

$(() => {
  $('body').scrollspy({ target: '#features-nav' })
  var sticky_height = $('.landing-cover-container').outerHeight() + ($('#features-nav').outerHeight() || 0)

  $(window).scroll(function () {
    var sticky_features = $('.features-nav'),
      sticky_landing = $('.landing-cover-container'),
      scroll = $(window).scrollTop()
    if (scroll >= 148) { // height of sticky nav
      sticky_features.addClass('fixed-features')
      sticky_landing.addClass('fixed-header-nav')
      $('body').attr('style', `margin-top: ${sticky_height}px !important;`) // height of main landing container
    } else {
      sticky_features.removeClass('fixed-features')
      sticky_landing.removeClass('fixed-header-nav')
      $('body').attr('style', 'margin-top: 0px !important;')
    }
  })

  new Carousel()
})

